import React, { Fragment as F } from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import set from 'lodash/set'
import moment from 'moment'
import sanitizeHtml from 'sanitize-html'

import Trades from 'components/Quote/Trades'
import Icon from 'discada/dist/Icon'
import { GET } from 'actions/apiActions'

import Button from 'discada/dist/Button'
import { RawExpando } from 'discada/dist/Expando'
import Loading from 'discada/dist/Loading'
import StateFeeTaxForm from 'components/forms/StateFeeTaxForm'

import Disclaimer from 'components/widgets/Disclaimer'

import { Fastpass, LibertyMutual } from 'components/widgets/Fastpass'

import {
  getBankByCode,
  getTaggedCustomerFromState,
  getRooftopName,
  getRooftopSalesPhone,
  getCreditAppLlink,
  getAccessoriesLink,
  getDrLink,
} from 'selectors/appStatusSelectors'
import { isEmail, isMobilePhone } from 'validator'

import {
  Field,
  TextField,
  SimpleTextField,
  ValueSelector,
  TextAreaField,
} from 'discada/dist/Form'

import { getFirstImage } from 'selectors/inventorySelectors'

import {
  getQuote,
  getQuoteValue,
  getQuoteDirty,
  getBestProgram,
  getQuoteShortLink,
  getInsurancePartnerLink,
  getBlinderShortLink,
  getIsLoading,
  doesQuoteHaveTaxes,
} from 'selectors/quoteSelectors'

import { getWritePermission } from 'selectors/authSelectors'
import { money, formatPhone } from 'utils'
import { INTENTS, INTENTS_EMOJI, INTENTS_LABELS } from 'reducers/quoteReducers'
import {
  saveQuote,
  changeQuote,
  forceRoll,
  getProgramsForQuote,
  resetQuote,
  getMarketForZip,
  setCurrentQuoteDirty,
} from 'actions/quoteActions'
import { addToPageState } from 'actions/pageStateActions'
import { flushByType } from 'actions/naughtyActions'
import { tagCustomer, hydrateCustomer } from 'actions/appStatusActions'
import { getQueryValue } from 'selectors/pageStateSelectors'
import { getIsSalesRooftop } from 'selectors/naughtySelectors'

import Scheduler from 'components/widgets/Scheduler'
import abeo from 'static/images/abe-o.png'

import './QuoteSaveForm.scss'

export const HEADERS = {
  lease: {
    title: ({ leaseTerm }, { Payment }) => (
      <F>
        Your <span className="payment-type">Lease</span> payment is{' '}
        <span className="payment">{money(Payment)}</span> for{' '}
        <span className="term">{leaseTerm} months</span>
      </F>
    ),
    subTitle: ({ down }, { Rate }, bankName) =>
      `with ${money(
        down,
      )} due at signing and a rate of ${Rate} from ${bankName}`,
  },
  loan: {
    title: ({ loanTerm }, { Payment }) => (
      <F>
        Your <span className="payment-type">Loan</span> payment is{' '}
        <span className="payment">{money(Payment)}</span> for{' '}
        <span className="term">{loanTerm} months</span>
      </F>
    ),
    subTitle: ({ down }, { Rate }, bankName) =>
      `with ${money(down)} due at signing and a ${Rate} APR from ${bankName}`,
  },
  cash: {
    title: (_, { TotalCashDue }) => (
      <F>
        Your <span className="payment-type">Cash Price</span> is{' '}
        <span className="payment">{money(TotalCashDue)}</span>
      </F>
    ),
    subTitle: () =>
      'This price includes all applicable discounts, fees and taxes',
  },
}

export class SimpleQuoteSaveForm extends StateFeeTaxForm {
  constructor(...args) {
    super(...args)

    this.doSave = () => {
      let {
          vehicleId,
          quoteId,
          mode,
          onCancel,
          saveQuote,
          getMarketForZip,
          intent,
          closeOnSave,
          addendum = {},
          onAfterSave = () => {},
          addToPageState,
        } = this.props,
        {
          customerZipCode,
          customerComments,
          taxRegionId,
          stateFeeTax,
          customer,
          appointment,
        } = this.state,
        rateMarket

      return this.tagCustomer()
        .then(() => getMarketForZip(customerZipCode))
        .then(market => {
          if (typeof market !== 'number') {
            this.setState({ zipError: true })
            throw new Error(`Invalid ZIP ${customerZipCode}, ${market}`)
          } else {
            rateMarket = market
          }
        })
        .then(() => closeOnSave && onCancel())
        .then(() => {
          this.setState({ zipError: false, userEdit: false })

          return saveQuote(
            vehicleId,
            quoteId,
            mode,
            intent,
            {
              ...addendum,
              intent,
              customer,
              appointment,
              customerZipCode,
              customerComments,
              rateMarket,
              taxRegionId,
              stateFeeTax,
            },
            true,
          )
        })
        .then(() => addToPageState({ quoteSaved: true }))
        .then(() => onAfterSave())
        .catch(e => console.log('Bad Zip', e))
    }
  }

  async tagCustomer(syncState = true) {
    // async to allow for promise chaining
    let { hydrateCustomer } = this.props,
      zipCode = this.state.customerZipCode,
      { regionConfigurations, taxRegionId, stateFeeTax } = this.state,
      taxRegionLabel = this.getRegionLabel(
        get(regionConfigurations, taxRegionId),
      ),
      customer = {
        ...get(this.state, 'customer', {}),
        zipCode,
        taxRegionId,
        stateFeeTax,
        taxRegionLabel,
        location: {
          zipCode,
          taxRegionId,
          taxRegionLabel,
          stateFeeTax,
        },
      }

    hydrateCustomer(customer)
    syncState && this.setState({ customer })
  }

  onAfterRegionSelect() {
    this.props.setCurrentQuoteDirty()
    false && this.tagCustomer()
  }

  componentDidUpdate(_, oldState) {
    if (this.state.customerZipCode !== oldState.customerZipCode)
      this.setState({ stateFeeTax: {} }, this.loadFormConfig)
  }

  static getDerivedStateFromProps(newProps, oldState) {
    let { userEdit } = oldState,
      { quoteData } = newProps,
      newState = !userEdit ? quoteData : {}

    return {
      ...oldState,
      ...newState,
    }
  }

  render() {
    let {
        program,
        intent,
        submitLabel = 'Save My Quote!',
        vehicleId,
        quoteId,
        className,
        isLoading,
        isManager,
        children,
        image,
        quote,
        valid = true,
        insurancePartnerLink,
        postSaveMessage,
        quoteShortLink,
        onCancel,
        isTagged,
        flushByType,
        resetQuote,
        phoneNumber,
        creditAppLink,
        accessoriesLink,
        drLink,
        hideZip = false,
        title,
        quoteSaved,
      } = this.props,
      { zipError } = this.props,
      { customer } = this.state,
      { customerZipCode } = this.state,
      submitOk =
        valid &&
        customerZipCode &&
        customerZipCode.length === 5 &&
        (isManager ||
          (isEmail(get(customer, 'email', '')) ||
            isMobilePhone(get(customer, 'phone', '')))),
      onChange = (key, userEdit) => ({ target }) => {
        let state = { ...this.state }

        set(state, key, sanitizeHtml(target.value))

        this.setState({ userEdit: this.state.userEdit || userEdit, ...state })
      },
      clearCustomer = () => {
        onCancel()
        resetQuote(vehicleId, quoteId)
      }

    submitLabel = quoteShortLink ? 'Update Quote' : submitLabel

    if (intent !== INTENTS.created && isEmpty(program)) return <Loading />

    return (
      <RawExpando>
        {({ toggle }) => (
          <div
            className={c('quote-save-form', className)}
            style={{ backgroundImage: `url(${image.src})` }}
          >
            <div className="quote-save-form-inner">
              <F>
                {title && (
                  <div className="title-wrapper">
                    <p className="title">
                      <span className="customer-name">{title}</span>
                    </p>
                  </div>
                )}
                {INTENTS_LABELS[intent] && (
                  <span className="reaction-bubble">
                    {INTENTS_EMOJI[intent]} "{INTENTS_LABELS[intent]}"
                  </span>
                )}
                {!isLoading && quote.intent && postSaveMessage && (
                  <article className="message is-success">
                    <div className="message-body">
                      {postSaveMessage}
                      {quoteShortLink && (
                        <p className="link-copy">
                          We've personalized your payments to match your zip
                          code.
                          <br /> Be sure to <strong>SAVE THIS LINK</strong> to
                          pick up where you left off or to share: <br />
                          <br />
                          <a
                            href={quoteShortLink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {quoteShortLink}
                          </a>
                        </p>
                      )}
                    </div>
                  </article>
                )}
                {!quoteSaved && (
                  <>
                    <hr />
                    <div className="contact-fields">
                      <label>Tell us about yourself</label>
                      <Field inline>
                        {fieldProps => (
                          <React.Fragment>
                            <div className="field">
                              <SimpleTextField
                                {...fieldProps}
                                placeholder="Your First Name *"
                                leftIcon="user"
                                value={get(customer, 'firstName', '')}
                                onChange={onChange('customer.firstName')}
                                onBlur={() => this.tagCustomer()}
                                rounded
                              />
                            </div>
                            <div className="field">
                              <SimpleTextField
                                {...fieldProps}
                                placeholder="Your Last Name *"
                                leftIcon="user"
                                value={get(customer, 'lastName', '')}
                                onChange={onChange('customer.lastName')}
                                onBlur={() => this.tagCustomer()}
                                rounded
                              />
                            </div>
                          </React.Fragment>
                        )}
                      </Field>
                      <Field inline>
                        {fieldProps => (
                          <React.Fragment>
                            <div className="field">
                              <SimpleTextField
                                {...fieldProps}
                                inline
                                placeholder="Your Email Address"
                                leftIcon="envelope"
                                value={get(customer, 'email', '')}
                                onChange={onChange('customer.email')}
                                onBlur={() => this.tagCustomer()}
                                validateFor="email"
                                rounded
                              />
                            </div>

                            <div className="field">
                              <SimpleTextField
                                {...fieldProps}
                                inline
                                placeholder="Your Phone Number"
                                leftIcon="mobile"
                                value={get(customer, 'phone', '')}
                                onChange={onChange('customer.phone')}
                                onBlur={() => this.tagCustomer()}
                                validateFor="phone"
                                rounded
                              />
                            </div>
                          </React.Fragment>
                        )}
                      </Field>
                    </div>
                    <br />
                    {!hideZip && intent !== INTENTS.created && (
                      <Field
                        label="Verify Your Zip Code to see the most accurate payments"
                        className="side-by"
                      >
                        <div className="field">
                          <SimpleTextField
                            rounded
                            placeholder="Your Zip Code"
                            leftIcon="map-marker-alt"
                            value={customerZipCode}
                            onChange={({ target }) => {
                              this.setState({
                                userEdit: true,
                                customerZipCode: target.value,
                              })
                            }}
                            xonBlur={({ target }) => {
                              this.props.tagCustomer(vehicleId, quoteId, null, {
                                zipCode: target.value,
                              })
                            }}
                            danger={zipError}
                            error={zipError && 'Please enter a valid zip code'}
                          />
                        </div>
                        {this.getRegionSelectField()}
                      </Field>
                    )}
                    {children && <hr />}
                    {typeof children === 'function'
                      ? children(this.state, onChange)
                      : children}
                    <hr />
                    {(!isManager || !isEmpty(this.state.customerComments)) && (
                      <TextAreaField
                        rounded
                        label={
                          isManager
                            ? 'Customer Comments'
                            : 'Do you have any comments or questions for us?'
                        }
                        value={this.state.customerComments}
                        onChange={({ target }) =>
                          this.setState({
                            userEdit: true,
                            customerComments: target.value,
                          })
                        }
                      />
                    )}
                  </>
                )}
                {get(insurancePartnerLink, 'partner') ===
                  'dealerPolicyFastPass' && (
                  <Fastpass fastpass={insurancePartnerLink} />
                )}
                {get(insurancePartnerLink, 'partner') === 'libertyMutual' && (
                  <LibertyMutual insurancePartnerLink={insurancePartnerLink} />
                )}
                {!isManager && phoneNumber && (
                  <h5 className="phone-number">
                    Give us a call!{' '}
                    <strong>
                      <a href={`tel:${phoneNumber}`}>
                        <Icon icon="phone" /> {formatPhone(phoneNumber)}
                      </a>
                    </strong>
                  </h5>
                )}
                <div className="buttons submit-set inline">
                  <div className="submit-set-body">
                    {!quoteSaved && (
                      <Button
                        success
                        icon="share"
                        disabled={!submitOk || isLoading}
                        onClick={this.doSave}
                        loading={!!isLoading}
                      >
                        {submitLabel}
                      </Button>
                    )}
                    {!hideZip && intent !== INTENTS.created && drLink && (
                      <Button
                        primary
                        icon="shopping-cart"
                        disabled={!submitOk || isLoading}
                        onClick={() => {
                          window.open(drLink) && this.doSave()
                        }}
                        loading={!!isLoading}
                      >
                        Buy Online
                      </Button>
                    )}
                    {!hideZip && intent !== INTENTS.created && creditAppLink && (
                      <Button
                        primary
                        icon="credit-card"
                        disabled={!submitOk || isLoading}
                        onClick={() => {
                          window.open(creditAppLink) && this.doSave()
                        }}
                        loading={!!isLoading}
                      >
                        Apply for Credit
                      </Button>
                    )}
                    {!hideZip && intent !== INTENTS.created && accessoriesLink && (
                      <Button
                        primary
                        icon="shopping-bag"
                        disabled={!submitOk || isLoading}
                        onClick={() => {
                          window.open(accessoriesLink) && this.doSave()
                        }}
                        loading={!!isLoading}
                      >
                        Browse Accessories
                      </Button>
                    )}
                    {onCancel && (
                      <Button text onClick={onCancel}>
                        Close
                      </Button>
                    )}
                    {toggle && isTagged && (
                      <Button
                        text
                        onClick={async () => {
                          await flushByType('customer')
                          clearCustomer()
                          toggle()
                        }}
                      >
                        Not {customer.firstName}?
                      </Button>
                    )}
                  </div>
                </div>
              </F>
              <Disclaimer className="reaction-form-disclaimer" />
            </div>
          </div>
        )}
      </RawExpando>
    )
  }
}

export function QuoteSaveForm(props) {
  if (!props.intent) return null

  let { isSalesRooftop } = props

  let intent = props.intent,
    Comp = {
      [INTENTS.created]: QuoteCreateForm,
      [INTENTS.accepted]: QuoteAcceptForm,
      [INTENTS.holdDeal]: QuoteHoldDealForm,
      [INTENTS.buyNow]: QuoteBuyNowForm,
      [INTENTS.rejected]: QuoteRejectForm,
      [INTENTS.getOTD]: QuoteGetOTDForm,
      [INTENTS.getCashPrice]: QuoteGetCashPriceForm,
      [INTENTS.revised]: QuoteSleepForm,
      [INTENTS.rolled]: QuoteRollForm,
      [INTENTS.shared]: QuoteShareForm,
      [INTENTS.cashRejected]: QuoteRejectForm,
      [INTENTS.contact]: QuoteContactForm,
      [INTENTS.tradeAppraisal]: QuoteTradeAppraisalForm,
    }[intent]

  return Comp ? <Comp {...props} intent={intent} /> : null
}

function mapStateToProps(state, op) {
  let gqv = (key, def) =>
      getQuoteValue(state, op.vehicleId, op.quoteId, key, def),
    program = getBestProgram(state, op.vehicleId, op.quoteId, op.mode),
    customer = gqv('customer', {}),
    taggedCustomer = getTaggedCustomerFromState(state),
    isTagged = get(taggedCustomer, 'firstName'),
    customerZipCode = gqv('customerZipCode'),
    appointment = gqv('appointment', {}),
    customerComments = gqv('customerComments', ''),
    quoteData = { customer, customerZipCode, appointment, customerComments }

  return {
    ...op,
    program,
    customer,
    isTagged,
    quoteData,
    customerZipCode,
    quoteSaved: getQueryValue(state, 'quoteSaved'),
    zipError: getQueryValue(state, 'changeZip') === 'error',
    quote: getQuote(state, op.vehicleId, op.quoteId, op.mode),
    taxRegionId: gqv('taxRegionId'),
    stateFeeTax: gqv('stateFeeTax'),
    rooftopName: getRooftopName(state),
    isSalesRooftop: getIsSalesRooftop(state),
    savedIntent: gqv('intent', {}),
    dirty: getQuoteDirty(state, op.vehicleId, op.quoteId),
    isManager: getWritePermission(state, 'deal.fields/profit'),
    quoteShortLink: getQuoteShortLink(state, op.vehicleId, op.quoteId),
    insurancePartnerLink: getInsurancePartnerLink(
      state,
      op.vehicleId,
      op.quoteId,
    ),
    blinderShortLink: getBlinderShortLink(state, op.vehicleId, op.quoteId),
    image: getFirstImage(state, op.vehicleId),
    bankName: getBankByCode(state, program.Lender),
    isLoading: getIsLoading(state, op.vehicleId, op.quoteId),
    hasFeesAndTaxes: doesQuoteHaveTaxes(state, op.vehicleId, op.quoteId),
    phoneNumber: getRooftopSalesPhone(state),
    creditAppLink: getCreditAppLlink(state),
    drLink: getDrLink(state),
    accessoriesLink: getAccessoriesLink(state),
    expirationValues: gqv('expirations'),
    expirationDays: gqv('expirationDays'),
    expirationDate: moment().add(gqv('expirationDays'), 'days'),
  }
}

export default connect(
  mapStateToProps,
  {
    tagCustomer,
    changeQuote,
    resetQuote,
    saveQuote,
    forceRoll,
    flushByType,
    getProgramsForQuote,
    getMarketForZip,
    addToPageState,
    taxFeeOptionsByZip: GET.taxFeeOptionsByZip,
    hydrateCustomer,
    setCurrentQuoteDirty,
  },
)(QuoteSaveForm)

/////// CUSTOM FORM BEGIN   /////////

export function QuoteCreateForm(props) {
  let {
    vehicleId,
    quoteId,
    changeQuote,
    expirationDays,
    expirationValues,
    expirationDate,
    className,
    savedIntent,
  } = props

  return (
    <SimpleQuoteSaveForm
      {...props}
      clean
      className={c('quote-create-form', className)}
      intent={savedIntent || INTENTS.created}
      submitLabel="Save Quote"
      createdBy="dealer"
      hideZip
    >
      {(state, onChange) => (
        <>
          {savedIntent && (
            <Scheduler
              {...props}
              {...state}
              onChange={onChange}
              intent={savedIntent}
            />
          )}
          <ValueSelector
            primary
            className="expiration-picker"
            selected={expirationDays}
            values={expirationValues}
            size="small"
            label="Expires In"
            onChange={v =>
              changeQuote(vehicleId, quoteId, {
                expirationDate,
                expirationDays: parseInt(v.value, 10),
              })
            }
            help={
              <span className="good-through">
                This offer is good through{' '}
                <strong>{expirationDate.format('LL')}</strong>
              </span>
            }
          />
        </>
      )}
    </SimpleQuoteSaveForm>
  )
}

export function QuoteAcceptForm(props) {
  let postSave = (
    <p>
      <strong>Thanks for your interest!</strong> We'll reach out to you soon.
      Feel free to keep playing in the meantime.
    </p>
  )

  return (
    <SimpleQuoteSaveForm
      {...props}
      className="quote-accept-form"
      intent={INTENTS.accepted}
      postSaveMessage={postSave}
    >
      {(state, onChange) => (
        <Scheduler {...props} {...state} onChange={onChange} />
      )}
    </SimpleQuoteSaveForm>
  )
}

export function QuoteTradeAppraisalForm(props) {
  let postSave = (
    <p>
      <strong>Thanks for your interest!</strong> We'll reach out to you soon.
      Feel free to keep playing in the meantime.
    </p>
  )

  return (
    <SimpleQuoteSaveForm
      {...props}
      className="quote-trade-appraisal-form"
      intent={INTENTS.tradeAppraisal}
      postSaveMessage={postSave}
    >
      {(state, onChange) => (
        <>
          <div className="reaction-trades">
            <label>What are you looking to trade-in?</label>
            <Trades {...props} createChangeEvent={false} />
          </div>
          <hr />
          <Scheduler {...props} {...state} onChange={onChange} />
        </>
      )}
    </SimpleQuoteSaveForm>
  )
}

export function QuoteBuyNowForm(props) {
  let preSave = (
      <p>
        <strong>Thanks for your interest!</strong> We'll reach out to you soon.
        Feel free to keep playing in the meantime.
      </p>
    ),
    postSave = (
      <p>
        <strong>Thanks for your interest!</strong> We'll reach out to you soon.
        Feel free to keep playing in the meantime.
      </p>
    )

  return (
    <div>
      <SimpleQuoteSaveForm
        {...props}
        className="quote-buy-now-form"
        intent={INTENTS.buyNow}
        preSaveMessage={preSave}
        postSaveMessage={postSave}
      >
        {(state, onChange) => (
          <Scheduler {...props} {...state} onChange={onChange} />
        )}
      </SimpleQuoteSaveForm>
    </div>
  )
}

export function QuoteHoldDealForm(props) {
  let postSave = (
    <p>
      <strong>Thanks for your interest!</strong> We'll reach out to you soon.
      Feel free to keep playing in the meantime.
    </p>
  )

  return (
    <SimpleQuoteSaveForm
      {...props}
      className="quote-holdDeal-form"
      intent={INTENTS.holdDeal}
      postSaveMessage={postSave}
    />
  )
}

export class QuoteRejectForm extends React.Component {
  state = { desiredPayment: 0 }

  static getDerivedStateFromProps(newProps, oldState) {
    return {
      desiredPayment:
        oldState.desiredPayment || get(newProps, 'quote.desiredPayment'),
    }
  }
  render() {
    let { vehicleId, quoteId, mode, changeQuote } = this.props,
      { desiredPayment } = this.state,
      postSave = (
        <p>
          <strong>You'll hear from us soon!</strong> We'll reach out to you soon
          with a new quote that should better meet your needs. In the meantime,
          feel free to keep playing.
        </p>
      )

    return (
      <SimpleQuoteSaveForm
        {...this.props}
        className="quote-reject-form"
        intent={mode === 'cash' ? INTENTS.cashRejected : INTENTS.rejected}
        submitLabel="Help me get to my payment!"
        postSaveMessage={postSave}
      >
        <TextField
          className="roll-field"
          label={`I want my ${
            mode === 'cash' ? 'price' : 'monthly payment'
          } to be...`}
          leftIcon="dollar-sign"
          value={desiredPayment}
          onChange={({ target }) =>
            this.setState({ desiredPayment: target.value })
          }
          onBlur={({ target }) =>
            changeQuote(vehicleId, quoteId, { desiredPayment: target.value })
          }
          rounded
        />
      </SimpleQuoteSaveForm>
    )
  }
}

export function QuoteContactForm(props) {
  let preSave = (
      <p>
        <strong>Let's save your work for later!</strong>
        Tell us about yourself and we'll save your settings so you can come back
        later and pick up where you left off.
      </p>
    ),
    postSave = (
      <p>
        <strong>Your work has been saved!</strong>
      </p>
    ),
    title = (
      <>
        <strong>INSTANTLY</strong> get access to <strong>UNLIMITED</strong>{' '}
        payment and price quotes for you to personalize.
      </>
    )

  return (
    <SimpleQuoteSaveForm
      {...props}
      title={title}
      className="quote-sleep-form"
      intent={INTENTS.contact}
      preSaveMessage={preSave}
      postSaveMessage={postSave}
    />
  )
}

export function QuoteSleepForm(props) {
  let preSave = (
      <p>
        <strong>Let's save your work for later!</strong>
        Before you go, let's make sure we save the latest version of your custom
        quote so you can come back later.
      </p>
    ),
    postSave = (
      <p>
        <strong>Your work has been saved!</strong>
      </p>
    )

  return (
    <SimpleQuoteSaveForm
      {...props}
      className="quote-sleep-form"
      intent={INTENTS.revised}
      preSaveMessage={preSave}
      postSaveMessage={postSave}
    />
  )
}

export class QuoteRollForm extends React.Component {
  state = { desiredPayment: 0 }

  static getDerivedStateFromProps(newProps, oldState) {
    return {
      desiredPayment:
        oldState.desiredPayment || get(newProps, 'quote.desiredPayment'),
    }
  }

  render() {
    let {
        vehicleId,
        quoteId,
        mode,
        changeQuote,
        forceRoll,
        onCancel,
      } = this.props,
      { desiredPayment } = this.state,
      preSave = (
        <p>
          <strong>We can help you get to your payment!</strong>
          Tell us the payment you're trying to get to and we can customize this
          quote and help to get you there.
        </p>
      ),
      postSave = (
        <p>
          <strong>Your work has been saved!</strong>
        </p>
      )

    return (
      <SimpleQuoteSaveForm
        {...this.props}
        className="quote-roll-form"
        intent={INTENTS.rolled}
        submitLabel="Show me my payment!"
        preSaveMessage={preSave}
        postSaveMessage={postSave}
        onAfterSave={() => {
          forceRoll(vehicleId, quoteId, mode).then(onCancel)
        }}
      >
        <TextField
          rounded
          className="roll-field"
          label={`I want my ${
            mode === 'cash' ? 'price' : 'monthly payment'
          } to be...`}
          leftIcon="dollar-sign"
          value={desiredPayment}
          onChange={({ target }) =>
            this.setState({ desiredPayment: target.value })
          }
          onBlur={({ target }) => {
            changeQuote(vehicleId, quoteId, { desiredPayment: target.value })
          }}
        />
      </SimpleQuoteSaveForm>
    )
  }
}

export function QuoteShareForm(props) {
  let postSave = (
    <p>
      <strong>Your work has been saved!</strong> Use the link below to share
      this quote with a friend.
    </p>
  )

  return (
    <SimpleQuoteSaveForm
      {...props}
      className="quote-share-form"
      intent={INTENTS.shared}
      submitLabel="Generate share link"
      postSaveMessage={postSave}
    />
  )
}

export class QuoteGetOTDForm extends React.Component {
  render() {
    let preSave = (
        <p>
          <strong>Let's save your work first!</strong>
          We'll create a special link you can share or keep for yourself so that
          you can come back to this custom quote at anytime.
        </p>
      ),
      postSave = (
        <p>
          <strong>Your work has been saved!</strong>
        </p>
      )

    return (
      <SimpleQuoteSaveForm
        {...this.props}
        className="quote-getOTD-form"
        intent={INTENTS.getOTD}
        preSaveMessage={preSave}
        postSaveMessage={postSave}
        submitLabel="Personalize My Payments"
        forceProgramUpdate
        closeOnSave
      />
    )
  }
}

export class QuoteGetCashPriceForm extends React.Component {
  render() {
    let preSave = (
        <p>
          <strong>Let's save your work first!</strong>
          We'll create a special link you can share or keep for yourself so that
          you can come back to this custom quote at anytime.
        </p>
      ),
      postSave = (
        <p>
          <strong>Your work has been saved!</strong>
        </p>
      ),
      { vehicleId, quoteId, changeQuote } = this.props

    return (
      <SimpleQuoteSaveForm
        {...this.props}
        className="quote-getCashPrice-form"
        intent={INTENTS.getCashPrice}
        preSaveMessage={preSave}
        postSaveMessage={postSave}
        forceProgramUpdate
        closeOnSave
        onAfterSave={() => changeQuote(vehicleId, quoteId, { mode: 'cash' })}
      />
    )
  }
}
